export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. Utilizamos sistemas de pago encriptados y seguros. Tu información está protegida.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Un pago único. Acceso de por vida. Sin suscripción ni pagos recurrentes.'
  },
  {
    q: '¿Sirve para profesores con poca experiencia?',
    a: 'Totalmente. El Bono #1 "Mapa Flash de Arranque" está diseñado precisamente para eso: que cualquier profesor, sea novel u experimentado, tome el control de un grupo en 7 días.'
  },
  {
    q: '¿Puedo usarlo solo para una etapa concreta?',
    a: 'Por supuesto. Compras el sistema completo, pero puedes usar solo los tomos que necesites. El precio es el mismo.'
  },
  {
    q: '¿Qué pasa si tengo alumnos de distintos niveles en la misma clase?',
    a: 'Cada sesión incluye una Variante Flash específica para diferenciación. Además, los 11 tomos están organizados por maduración progresiva, así que siempre hay escala de dificultad.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'PDF de alta calidad, optimizado para móviles, tablets y PC. Puedes leerlo en cualquier dispositivo o imprimirlo en A4.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  }
];
